// Third-party
import React from 'react';

// Components
import PrimaryLink from '../buttons/PrimaryLink';
import BenchmarksModal from '../modals/BenchmarksModal';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  activeBenchmark?: ComparisonItem;
  linkDisabled: boolean;
  item: ComparisonItem;
};

type State = {
  modalIsOpen: boolean;
};

class BenchmarkViewer extends React.Component<Props, State> {
  readonly state: State = {
    modalIsOpen: false,
  };

  openModal = (event: React.MouseEvent) => {
    if (this.props.linkDisabled) {
      return;
    }
    event.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  render() {
    const { modalIsOpen } = this.state;
    const { activeBenchmark, item, linkDisabled } = this.props;

    return (
      <div className="benchmark-viewer">
        <span className="markup-container">
          <PrimaryLink onClick={this.openModal} disabled={linkDisabled} icon="arrow-up-right2">
            <FormattedMessage id="Comparison.BenchmarkAction" />
          </PrimaryLink>
        </span>
        <BenchmarksModal activeBenchmark={activeBenchmark} item={item} show={modalIsOpen} onConfirm={this.closeModal} onCancel={this.closeModal} />
      </div>
    );
  }
}

export default BenchmarkViewer;
